export default "__VITE_ASSET__Dmwg9JrK__"